<script>
import {action$LoadDocs} from "../vendor/qconstants";
import store from '@/store/store';
import {ebus} from "@/vendor/ebus";
import * as xhr from "@/api/xhr";


export default {
  name: 'DiscountsLifecycle',
  data: () => ({
    loaded: false,
  }),
  created() {
    ebus.$on('loadDiscounts', () => {
      this.loadDiscounts();
    });
  },
  beforeMount() {
    this.loadDiscounts();
  },
  mounted() {
    setTimeout(() => {
      this.checkLoad();
    }, 3000);
  },
  methods: {
    checkLoad() {
      if (!this.loaded) {
        setTimeout(() => {
          //retry
          this.loadDiscounts()
        }, 4000);
      }
    },

    async loadDiscounts() {
      console.log("loadDiscounts...");
      let msg = {
        action: action$LoadDocs,
        collectionName: 'discounts',
        query: {
          isActive: true,
        }
      };
      await xhr.xhrSend(true, msg, (data) => {
        if (data && data.ok && data.docs && Array.isArray(data.docs)) {
          let docs = data.docs;
          if (Array.isArray(docs)) {
            store.commit('discounts', docs);
            console.log('loaded active discounts: ' + docs.length);
            this.loaded = true;
          }
        }
      }, (err) => {
        console.log('error loading active discounts');
      });
    },

  }// eof methods
}
</script>
<template>
  <div></div>
</template>
<style scoped>

</style>
